(function () {
  'use strict';

  const DESKTOP_MIN = 1025;
  const TRANSITION_MS = 400;
  const cardState = new WeakMap();
  let wasDesktop = window.innerWidth >= DESKTOP_MIN;
  let resizeTimer = null;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  // Prefer shared helper from GtmEvents-script; fall back to local width check
  function isPlpDesktop() {
    if (typeof window.isPlpGalleryDesktopBreakpoint === 'function') {
      return window.isPlpGalleryDesktopBreakpoint();
    }
    return isDesktop();
  }

  function emitPlpImageHover(card, imageIndexZeroBased) {
    if (typeof window.handlePlpProductImageHover === 'function') {
      window.handlePlpProductImageHover(card, imageIndexZeroBased);
    }
  }

  function emitPlpImageSwipe(card, imageIndexZeroBased) {
    if (typeof window.handlePlpProductImageSwipe === 'function') {
      window.handlePlpProductImageSwipe(card, imageIndexZeroBased);
    }
  }

  // Spec / dynamic card loaders
  window.initPlpProductCardsInContainer = function (container) {
    window.initializeProductCardSwipers(container);
  };
  window.bindPlpGalleryTouchIsolation = function () {};
  if (typeof window.isPlpGalleryDesktopBreakpoint !== 'function') {
    window.isPlpGalleryDesktopBreakpoint = isDesktop;
  }

  function getPlpCards(container) {
    const root = container || document;
    let gridContainer = null;

    if (root.id === 'ProductGridContainer') {
      gridContainer = root;
    } else if (root.querySelector) {
      gridContainer = root.querySelector('#ProductGridContainer');
    }

    if (!gridContainer) {
      gridContainer = document.getElementById('ProductGridContainer');
    }

    if (gridContainer) {
      return gridContainer.querySelectorAll('#product-grid .grid__item .product-card-wrapper.plp-multi-image');
    }

    return document.querySelectorAll('.product-grid-container #product-grid .grid__item .product-card-wrapper.plp-multi-image');
  }

  function getCardElements(card) {
    const media = card.querySelector('.card__media .media');
    return {
      media,
      firstImage: media ? media.querySelector('.product-first-image') : null,
      swiperWrapper: media ? media.querySelector('.product-swiper-wrapper') : null,
      swiperEl: media ? media.querySelector('.product-card-swiper') : null,
    };
  }

  function getImageCount(card) {
    const { swiperEl } = getCardElements(card);
    if (!swiperEl) return 0;

    const dataCount = parseInt(swiperEl.dataset.imageCount || '0', 10);
    if (dataCount > 0) return dataCount;

    return swiperEl.querySelectorAll('.swiper-slide').length;
  }

  function resetInlineImageStyles(card) {
    const { firstImage, swiperWrapper } = getCardElements(card);
    if (firstImage) firstImage.style.removeProperty('display');
    if (swiperWrapper) swiperWrapper.style.removeProperty('display');
  }

  function showFirstImage(card) {
    const { firstImage, swiperWrapper, swiperEl } = getCardElements(card);

    card.classList.remove('plp-swiper-active');
    if (swiperEl) swiperEl.classList.remove('is-zoom-active');

    if (!isDesktop()) {
      if (firstImage) firstImage.style.display = 'none';
      if (swiperWrapper) swiperWrapper.style.display = 'block';
    }
  }

  function showSwiper(card) {
    const { firstImage, swiperWrapper } = getCardElements(card);

    if (isDesktop()) {
      card.classList.add('plp-swiper-active');
    } else {
      card.classList.remove('plp-swiper-active');
      if (firstImage) firstImage.style.display = 'none';
      if (swiperWrapper) swiperWrapper.style.display = 'block';
    }
  }

  function updateMobileZoom(swiperEl, swiperInstance) {
    if (!swiperEl || !swiperInstance || isDesktop()) return;

    if (swiperInstance.activeIndex === 1) {
      swiperEl.classList.add('is-zoom-active');
    } else {
      swiperEl.classList.remove('is-zoom-active');
    }
  }

  function destroySwiperElement(swiperEl) {
    if (!swiperEl) return;

    if (swiperEl.swiper && typeof swiperEl.swiper.destroy === 'function') {
      swiperEl.swiper.destroy(true, true);
    }

    swiperEl.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-pointer-events', 'is-zoom-active');
  }

  function refreshSwiperLayout(swiperInstance) {
    if (!swiperInstance || typeof swiperInstance.update !== 'function') return;

    swiperInstance.update();

    if (typeof swiperInstance.scrollbar?.updateSize === 'function') {
      swiperInstance.scrollbar.updateSize();
    }
  }

  function scheduleSwiperLayoutRefresh(swiperInstance) {
    requestAnimationFrame(function () {
      refreshSwiperLayout(swiperInstance);
      requestAnimationFrame(function () {
        refreshSwiperLayout(swiperInstance);
      });
    });
  }

  function createSwiperInstance(card, swiperEl) {
    destroySwiperElement(swiperEl);

    const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');

    const swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      preventClicks: true,
      preventClicksPropagation: true,
      threshold: 10,
      touchStartPreventDefault: false,
      resistanceRatio: 0.85,
      observer: true,
      observeParents: true,
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true,
            hide: false,
          }
        : undefined,
      on: {
        slideChange: function () {
          updateMobileZoom(swiperEl, this);

          // GTM only — do not change slide behaviour
          if (isPlpDesktop()) return;
          if (this.__plpProgrammatic) return;
          if (typeof this.activeIndex !== 'number') return;
          if (this.activeIndex === this.previousIndex) return;
          emitPlpImageSwipe(card, this.activeIndex);
        },
        init: function () {
          updateMobileZoom(swiperEl, this);
          scheduleSwiperLayoutRefresh(this);
        },
      },
    });

    const state = cardState.get(card) || {};
    state.swiper = swiperInstance;
    cardState.set(card, state);

    scheduleSwiperLayoutRefresh(swiperInstance);

    return swiperInstance;
  }

  function destroyCard(card) {
    const state = cardState.get(card) || {};

    if (state.destroyTimer) {
      clearTimeout(state.destroyTimer);
      state.destroyTimer = null;
    }

    if (state.swiper) {
      state.swiper.destroy(true, true);
      state.swiper = null;
    }

    const { swiperEl } = getCardElements(card);
    destroySwiperElement(swiperEl);

    if (state.onMouseEnter) {
      card.removeEventListener('mouseenter', state.onMouseEnter);
      card.removeEventListener('mouseleave', state.onMouseLeave);
      state.onMouseEnter = null;
      state.onMouseLeave = null;
    }

    card.classList.remove('plp-swiper-active');

    resetInlineImageStyles(card);
    card.removeAttribute('data-plp-swiper-init');
    cardState.delete(card);
  }

  function setupDesktopCard(card) {
    const state = {};
    cardState.set(card, state);
    showFirstImage(card);

    state.onMouseEnter = function () {
      if (state.destroyTimer) {
        clearTimeout(state.destroyTimer);
        state.destroyTimer = null;
      }

      const { swiperEl } = getCardElements(card);
      if (!swiperEl) return;

      showSwiper(card);

      if (!state.swiper || state.swiper.destroyed) {
        state.swiper = createSwiperInstance(card, swiperEl);
      }

      const swiperInstance = state.swiper;
      if (swiperInstance && swiperInstance.slides.length > 1) {
        var beforeIndex = swiperInstance.activeIndex;
        swiperInstance.__plpProgrammatic = true;
        swiperInstance.slideTo(1, 0);
        swiperInstance.__plpProgrammatic = false;
        swiperEl.classList.add('is-zoom-active');

        if (beforeIndex !== 1) {
          emitPlpImageHover(card, 1);
        }
      }

      cardState.set(card, state);
    };

    state.onMouseLeave = function () {
      const { swiperEl } = getCardElements(card);

      if (swiperEl) swiperEl.classList.remove('is-zoom-active');
      showFirstImage(card);

      state.destroyTimer = setTimeout(function () {
        if (state.swiper) {
          state.swiper.destroy(true, true);
          state.swiper = null;
        }
        destroySwiperElement(swiperEl);
        state.destroyTimer = null;
        cardState.set(card, state);
      }, TRANSITION_MS);

      cardState.set(card, state);
    };

    card.addEventListener('mouseenter', state.onMouseEnter);
    card.addEventListener('mouseleave', state.onMouseLeave);
    cardState.set(card, state);
    card.setAttribute('data-plp-swiper-init', 'true');
  }

  function setupMobileCard(card) {
    const { swiperEl } = getCardElements(card);
    if (!swiperEl) return;

    showSwiper(card);
    createSwiperInstance(card, swiperEl);
    card.setAttribute('data-plp-swiper-init', 'true');
  }

  function setupCard(card) {
    if (!card.classList.contains('plp-multi-image')) return;
    if (getImageCount(card) <= 1) return;

    destroyCard(card);
    resetInlineImageStyles(card);

    if (isDesktop()) {
      setupDesktopCard(card);
    } else {
      setupMobileCard(card);
    }
  }

  function reinitOnBreakpointChange() {
    const plpGrid = document.getElementById('ProductGridContainer');
    const cards = getPlpCards(plpGrid || document);

    cards.forEach(function (card) {
      destroyCard(card);
    });

    if (plpGrid) {
      window.initializeProductCardSwipers(plpGrid);
    }
  }

  window.initializeProductCardSwipers = function (container) {
    if (typeof Swiper === 'undefined') return;

    const cards = getPlpCards(container);

    cards.forEach(function (card) {
      if (card.getAttribute('data-plp-swiper-init') === 'true') return;
      setupCard(card);
    });
  };

  window.reinitializeProductCardSwipers = function (container) {
    if (typeof Swiper === 'undefined') return;

    const cards = getPlpCards(container);

    cards.forEach(function (card) {
      destroyCard(card);
    });

    cards.forEach(function (card) {
      setupCard(card);
    });
  };

  function boot() {
    const plpGrid = document.getElementById('ProductGridContainer');
    if (!plpGrid) return;
    window.initializeProductCardSwipers(plpGrid);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      const nowDesktop = isDesktop();
      if (nowDesktop !== wasDesktop) {
        wasDesktop = nowDesktop;
        reinitOnBreakpointChange();
      }
    }, 150);
  });
})();
